<div *ngIf="isLoading" class="overlay">
  <mat-spinner class="loading-spinner" diameter="50"></mat-spinner>
</div>
<div class="news-container">
  <app-update-news></app-update-news>
  <app-media-upload></app-media-upload>
</div>
